<div class="input-wrapper">
  <div class="input-wrapper__icon">
    <ng-content></ng-content>
  </div>

  <input
    type="text"
    [placeholder]="placeholder"
    [ngClass]="{ 'custom-invalid': invalid }"
    [disabled]="disabled"
    [value]="value"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
    pInputText
  />
</div>
